import {
  orangeShades,
  primaryColors,
  transparentColors,
  whiteShades,
  buttonWhite,
  buttonOrange
} from '@assets/styles/helpers/colors.styles'
import { floatingSurface } from '@/shared/styles/floatingSurface.styles'

export const tooltipStyles = {
  background: 'red',
  fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
  fontWeight: 900,
  textTransform: 'uppercase'
}

export const popperStyles = {
  // Popper layout styles
  '.MuiDataGrid-columnsManagementHeader': {
    padding: '1rem 1rem 1rem 1rem !important'
  },
  '.MuiDataGrid-columnsManagement': {
    padding: '0 1.25rem',

    color: primaryColors.white,
    fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
    fontWeight: 900,
    textTransform: 'uppercase',
    fontSize: '14px',
    '&::-webkit-scrollbar': {
      width: '0.25rem'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: primaryColors.orange,
      borderRadius: '0.25rem'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: primaryColors.white,
      borderRadius: '0.25rem'
    },
    '&:hover': {
      '::-webkit-scrollbar': {
        width: '0.5rem',
        height: '0.5rem'
      },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: transparentColors.orangeShade6
      },
      '::-webkit-scrollbar-track': {
        backgroundColor: transparentColors.transparent
      }
    }
  },
  '.MuiDataGrid-columnsManagementFooter': {
    padding: '0.5rem 1.25rem 1rem 1.25rem !important',
    borderTop: 0
  },
  '.MuiDataGrid-paper': {
    ...floatingSurface
  },
  '.MuiInputBase-root': {
    color: buttonWhite.outlined.font,
    fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
    fontWeight: 900,
    height: '1.75rem',
    fontSize: '14px',
    padding: '0 0.375rem !important',

    '.MuiOutlinedInput-input': {
      padding: 0,
      textTransform: 'capitalize',

      '&::placeholder': {
        color: whiteShades.shade1,
        opacity: 1
      }
    },
    '.MuiInputAdornment-root': {
      margin: 0,
      paddingRight: '0.25rem',
      '.MuiSvgIcon-root': {
        fontSize: '20px !important',
        color: primaryColors.white
      }
    }
  },

  // Popper text and checkbox styles

  '.MuiFormControlLabel-root:hover': {
    '.MuiTypography-root': {
      color: buttonWhite.text.fontHover
    },
    '.MuiCheckbox-root .MuiSvgIcon-root': {
      color: buttonOrange.contained.backgroundHover
    }
  },

  '.MuiFormControlLabel-root .Mui-disabled': {
    color: `${whiteShades.shade1}`
  },

  '.MuiCheckbox-root': {
    color: `${primaryColors.orange} !important`,
    '&[aria-disabled="true"]': {
      color: `${orangeShades.shade1}`,
      '&.Mui-checked': {
        color: `${orangeShades.shade1}`
      }
    },
    '&.Mui-checked': {
      color: `${primaryColors.orange}`
    }
  },
  '[data-testid="IndeterminateCheckBoxIcon"]': {
    color: `${primaryColors.orange}`
  },
  '.MuiCheckbox-indeterminate': {
    color: `${primaryColors.orange}`
  },
  '.MuiTouchRipple-root': {
    display: 'none'
  },

  '.MuiTypography-root': {
    color: primaryColors.white,
    fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
    fontWeight: 900,
    textTransform: 'uppercase',
    fontSize: '14px'
  },

  // Popper hidden options

  '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root:first-of-type': {
    display: 'none'
  },

  '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root:nth-of-type(2)': {
    display: 'none'
  },

  '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root:nth-of-type(3)': {
    display: 'none'
  },

  '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root:nth-of-type(4)': {
    display: 'none'
  },

  '.MuiDataGrid-columnsManagement .MuiFormControlLabel-root:last-of-type': {
    display: 'none'
  },

  '.MuiOutlinedInput-notchedOutline': {
    border: `2px solid ${primaryColors.white} !important`,
    borderRadius: '0.25rem',

    '&:hover': {
      borderColor: `2px solid ${primaryColors.white}`
    }
  },
  '.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${primaryColors.white} !important`
  },

  '.MuiButton-text': {
    boxSizing: 'border-box',
    borderRadius: '0.25rem',

    fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
    fontWeight: 900,

    padding: '0',
    backgroundColor: buttonWhite.text.background,
    color: buttonWhite.text.font,
    border: 'none',
    '& .MuiSvgIcon-root': {
      fontSize: '1.5rem'
    },

    '&.Mui-disabled': {
      color: buttonWhite.text.fontDisabled
    },
    '&:hover': {
      color: buttonWhite.text.fontHover
    },
    '&:active': {
      color: buttonWhite.text.fontActive
    },
    '&:focus': {
      outline: 0
    },
    '.MuiButton-startIcon': {
      marginRight: '0'
    },
    '&[aria-expanded="true"]': {
      color: buttonWhite.text.fontActive
    }
  }
}

export const tableStyles = {
  borderLeft: 0,
  borderRight: 0,
  borderRadius: 0,
  overflowX: 'hidden',
  maxHeight: '100%',
  border: 0,
  width: '100%',
  minWidth: 0,

  // '& .MuiDataGrid-scrollbarFiller--pinnedRight': {
  //   backgroundColor: `${orangeShades.shade3} !important`
  // },

  '& .MuiDataGrid-row--lastVisible': {
    '& .MuiDataGrid-cell--pinnedRight': {
      borderRadius: '0 0 0.25rem 0'
    },
    '& .MuiDataGrid-cell--pinnedLeft': {
      borderRadius: '0 0 0 0.25rem'
    }
  },

  '& .MuiDataGrid-cell--pinnedRight, .MuiDataGrid-cell--pinnedLeft': {
    backgroundColor: transparentColors.whiteShade1,
    backdropFilter: 'blur(10px)',
    position: 'sticky !important',
    zIndex: '2 !important'
  },
  '& .MuiDataGrid-cell--pinnedRight': {
    right: '0 !important'
  },
  '& .MuiDataGrid-cell--pinnedLeft': {
    left: '0 !important'
  },
  // Ensure pinned columns container stays fixed
  '& .MuiDataGrid-pinnedColumns--right': {
    position: 'sticky !important',
    right: '0 !important',
    zIndex: '3 !important'
  },

  '& .MuiDataGrid-scrollShadow': {
    boxShadow: 'none'
  },

  '& .MuiDataGrid-mainContent': {
    backgroundColor: transparentColors.transparent,
    color: primaryColors.white,
    minWidth: '100%'
  },

  '& .MuiDataGrid-skeletonLoadingOverlay': {
    backgroundColor: transparentColors.whiteShade3
  },

  '& .MuiSkeleton-root': {
    backgroundColor: transparentColors.blackShade3
  },

  '& .MuiDataGrid-selectedRowCount': {
    // paddingTop: '1rem',
    // lineHeight: '20px',
    // letterSpacing: '0.25px',
    // fontFamily: 'helvetica-neue-lt-pro, sans-serif',
    // color: primaryColors.white,
    // margin: 0
    display: 'none'
  },

  '.MuiTablePagination-toolbar': {
    paddingLeft: '1rem',
    paddingTop: '0.75rem'
  },

  '.MuiTablePagination-spacer': {
    flex: 0
  },

  '.MuiTablePagination-displayedRows': {
    paddingRight: '0.5rem'
  },

  '.MuiPagination-ul': {
    flexWrap: 'nowrap'
  },

  '.MuiDataGrid-footerContainer': {
    border: 0
  },

  '.MuiTablePagination-actions': {
    '.MuiButtonBase-root': {
      color: buttonWhite.text.font,
      '&:hover': {
        color: buttonWhite.text.fontHover,
        background: 'transparent'
      },
      '&:focus': {
        outline: 0
      },
      '&.Mui-disabled': {
        color: buttonWhite.text.fontActive,
        '&:hover': {
          color: buttonWhite.text.fontActive
        }
      }
    }
  },

  '.MuiSelect-iconStandard': {
    color: primaryColors.white
  },

  '.MuiTablePagination-select': {
    marginRight: 'auto',
    padding: '0.25rem 0'
  },

  '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    fontFamily: 'helvetica-neue-lt-pro, sans-serif',
    color: primaryColors.white
  },

  '.MuiDataGrid-topContainer': {
    backgroundColor: transparentColors.transparent,
    borderRadius: '0 0 0.25rem 0.25rem'
  },

  '.MuiAvatar-root': {
    background: transparentColors.whiteShade3,
    color: primaryColors.white
  },

  '.MuiDataGrid-overlay': {
    fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
    fontWeight: 900,
    fontSize: '14px',
    textTransform: 'uppercase',
    borderRadius: '0.25rem'
  },
  '& .MuiInputBase-root': {
    color: buttonWhite.outlined.font,
    fontFamily: 'helvetica-neue-lt-pro-cond, sans-serif',
    fontWeight: 900,
    maxHeight: '1.5rem',
    fontSize: '14px',

    // maxWidth: '8rem',
    '.MuiInput-input': {
      padding: 0,
      textTransform: 'capitalize',
      '&::placeholder': {
        color: whiteShades.shade1,
        opacity: 1
      }
    }
  },

  '& .MuiInput-root::after': {
    display: 'none'
  },
  '& .MuiInput-root::before': {
    display: 'none'
  },
  '.MuiTextField-root.MuiDataGrid-toolbarQuickFilter': {
    padding: '0 0.25rem !important',
    backgroundColor: buttonWhite.outlined.background,
    border: `2px solid ${primaryColors.white}`,
    borderRadius: '0.25rem'
  },
  '.MuiTextField-root': {
    verticalAlign: 'middle'
  },

  '& [aria-label="Clear"]': {
    color: whiteShades.shade1,

    '&:hover': {
      color: whiteShades.shade2
    },
    '&:focus': {
      color: whiteShades.shade3,
      outline: 0
    },
    '&:active': {
      color: whiteShades.shade4
    }
  },

  '& .MuiTouchRipple-root': {
    display: 'none'
  },
  '& .MuiButton-textSizeSmall': {
    minWidth: '0',
    fontSize: '0',
    boxSizing: 'border-box',
    borderRadius: '0.25rem',
    maxHeight: '1.75rem',
    padding: '0',
    backgroundColor: buttonWhite.text.background,
    color: buttonWhite.text.font,
    border: 'none',
    '& .MuiSvgIcon-root': {
      fontSize: '1.5rem'
    },

    '&.Mui-disabled': {
      color: buttonWhite.text.fontDisabled
    },
    '&:hover': {
      color: buttonWhite.text.fontHover
    },
    '&:active': {
      color: buttonWhite.text.fontActive
    },
    '&:focus': {
      outline: 0
    },
    '.MuiButton-startIcon': {
      marginRight: '0'
    },
    '&[aria-expanded="true"]': {
      color: buttonWhite.text.fontActive
    }
  },
  '& ::-webkit-scrollbar': {
    width: '0.25rem',
    height: '0.25rem'
  },
  '& ::-webkit-scrollbar-track': {
    boxSizing: 'border-box',
    borderRadius: '1rem',
    backgroundColor: primaryColors.white,
    transition: 'background-color 0.5s ease-in-out'
  },
  '& ::-webkit-scrollbar-thumb': {
    borderRadius: '1rem',
    backgroundColor: primaryColors.orange,
    transition: 'background-color 0.5s ease-in-out'
  },

  '& .MuiDataGrid-scrollbar': {
    zIndex: 1,
    '&:hover': {
      '::-webkit-scrollbar': {
        width: '0.5rem',
        height: '0.5rem'
      },
      '::-webkit-scrollbar-thumb': {
        backgroundColor: transparentColors.orangeShade6
      },
      '::-webkit-scrollbar-track': {
        backgroundColor: transparentColors.transparent
      }
    },
    '&.MuiDataGrid-scrollbar--vertical': {
      top: '2.25rem',
      height: 'calc(100% - 2.5rem)',
      borderRadius: '1rem'
    },
    '&.MuiDataGrid-scrollbar--horizontal': {
      left: 0,
      width: 'calc(100% - 0.25rem)'
    }
  },
  '& .MuiDataGrid-virtualScroller': {
    boxSizing: 'border-box',
    borderRadius: '0.25rem',
    minWidth: '100%'
  },
  '& .MuiDataGrid-virtualScrollerContent': {
    minWidth: '100% !important'
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    minWidth: '100%'
  },
  '& .MuiDataGrid-scrollbar--horizontal': {
    right: 0
  },
  '.MuiDataGrid-columnHeader--lastUnpinned': {
    '.MuiDataGrid-columnSeparator': {
      display: 'none'
    }
  },
  '& .MuiDataGrid-columnHeader--siblingFocused .MuiDataGrid-columnSeparator': {
    opacity: 1
  },
  '& .MuiDataGrid-columnHeader:focus .MuiDataGrid-columnSeparator': {
    opacity: 1
  },
  '& .MuiDataGrid-iconSeparator': {
    color: primaryColors.black
  },
  '.MuiDataGrid-columnHeader--pinnedRight, .MuiDataGrid-columnHeader--pinnedLeft':
    {
      backgroundColor: `${orangeShades.shade2} !important`,
      position: 'sticky !important',
      zIndex: '31 !important',
      transform: 'none !important'
    },
  '& .MuiDataGrid-columnHeader--pinnedRight': {
    borderLeft: `1px solid ${primaryColors.black} !important`,
    right: '0 !important',
    transform: 'none !important'
  },
  '& .MuiDataGrid-columnHeader--pinnedLeft': {
    left: '0 !important'
  },
  // Ensure pinned column headers stay fixed during resize
  '& .MuiDataGrid-columnHeaderRow': {
    position: 'relative',
    minWidth: '100%',
    transform: 'none !important'
  },
  // Ensure column header container maintains full width to prevent pinned headers from moving
  '& .MuiDataGrid-columnHeaders': {
    minWidth: '100%',
    position: 'relative',
    overflow: 'visible',
    transform: 'none !important'
  },
  '& .MuiDataGrid-columnHeadersInner': {
    minWidth: '100%',
    transform: 'none !important'
  },
  '& .MuiDataGrid-pinnedColumnHeaders': {
    position: 'sticky !important',
    zIndex: '100 !important',
    backgroundColor: `${orangeShades.shade2} !important`,
    boxShadow: 'none !important',
    height: '32px',
    transform: 'none !important',
    right: '0 !important'
  },
  '& .MuiDataGrid-pinnedColumnHeaders--right': {
    right: '0 !important',
    top: '0 !important',
    transform: 'none !important'
  },
  '& .MuiDataGrid-pinnedColumnHeaders--left': {
    left: '0 !important'
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .MuiDataGrid-iconButtonContainer': {
      '& .MuiIconButton-root': {
        padding: 0,
        border: 0,
        outline: 0,
        color: primaryColors.orange
      }
    }
  },

  '& .MuiDataGrid-columnHeader--sorted': {
    backgroundColor: orangeShades.shade3
  },
  '& .MuiDataGrid-columnHeaders .MuiDataGrid-scrollbarFiller': {
    backgroundColor: orangeShades.shade2
  },
  '& .MuiDataGrid-scrollbarFiller.MuiDataGrid-scrollbarFiller--borderTop': {
    borderTop: `1px solid ${whiteShades.shade1}`
  },
  '& .MuiDataGrid-scrollbarFiller--header': {
    display: 'none'
  },
  '& .MuiDataGrid-scrollbarFiller--pinnedLeft': {
    display: 'none'
  },
  '& .MuiDataGrid-virtualScroller > [aria-hidden="true"]': {
    display: 'none'
  },

  '.MuiDataGrid-row--lastVisible': {
    borderRadius: '0 0 0.25rem 0.25rem'
  },

  '.MuiDataGrid-row--firstVisible.MuiDataGrid-row--lastVisible': {
    borderRadius: '0.25rem'
  },

  '& .MuiDataGrid-row--borderBottom .MuiDataGrid-columnHeader': {
    border: 0
  },
  '& .MuiDataGrid-topContainer': {
    border: 0,
    minWidth: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 4
  },
  '& .MuiDataGrid-filler': {
    display: 'none'
  },
  '& .MuiDataGrid-row': {
    zIndex: 1,
    '&:first-of-type .MuiDataGrid-scrollbarFiller': {
      border: 0
    }
  },
  '& .MuiDataGrid-columnHeader': {
    border: 0,
    backgroundColor: transparentColors.transparent,
    '&:last-of-type .MuiDataGrid-columnSeparator': {
      display: 'none'
    }
  },
  '.MuiDataGrid-cell': {
    borderTop: `1px solid ${whiteShades.shade1}`,
    overflow: 'hidden !important',
    minWidth: '0 !important',
    maxWidth: '100%',
    boxSizing: 'border-box',
    textOverflow: 'ellipsis !important',
    whiteSpace: 'nowrap !important',
    '&.MuiDataGrid-cell--editing': {
      backgroundColor: transparentColors.whiteShade2,
      boxShadow: 'none',
      '&:focus-within': {
        outline: 0
      }
    },
    '&.MuiDataGrid-cell--editable': {
      '.MuiInputBase-input': {
        border: `2px solid ${primaryColors.white}`,
        borderRadius: '0.25rem',
        margin: '0 0.5rem',
        padding: '0.25rem 0.5rem'
      }
    },
    // Custom editable cell styles
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: `${whiteShades.shade2} !important`,
      borderWidth: '2px !important'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: `${primaryColors.white} !important`
    },
    '.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: `${primaryColors.white} !important`
    }
  },

  '& .MuiDataGrid-columnHeader[data-field="action"], & .MuiDataGrid-cell[data-field="action"]':
    {
      paddingLeft: '0 !important',
      paddingRight: '0 !important'
    },

  '& .MuiDataGrid-columnHeader[data-field="action"] .MuiDataGrid-columnHeaderTitleContainer':
    {
      justifyContent: 'center'
    },

  '& .MuiDataGrid-cell[data-field="action"]': {
    justifyContent: 'center'
  },

  '& .MuiDataGrid-cell[data-field="action"] .MuiIconButton-root': {
    flexShrink: 0
  },

  // Increase specificity for cell content ellipsis (only for default MUI cell content, not custom renderCell)
  '&& .MuiDataGrid-cell': {
    '& .MuiDataGrid-cellContent': {
      overflow: 'hidden !important',
      textOverflow: 'ellipsis !important',
      whiteSpace: 'nowrap !important',
      minWidth: '0 !important',
      maxWidth: '100%',
      display: 'block !important'
    }
  },

  '& .MuiDataGrid-cellContent': {
    overflow: 'hidden !important',
    textOverflow: 'ellipsis !important',
    whiteSpace: 'nowrap !important',
    width: '100%',
    minWidth: '0 !important',
    maxWidth: '100%',
    display: 'block !important'
  },

  '& .MuiDataGrid-row--firstVisible': {
    '& .MuiDataGrid-cell': {
      borderTop: 0
    }
  },

  '.MuiDataGrid-cell:focus-within': {
    outline: 0
  },

  '.MuiDataGrid-columnHeader:focus .MuiDataGrid-columnSeparator--resizable': {
    color: primaryColors.orange
  },
  '.MuiDataGrid-columnHeader .hideRightSeparator > .MuiDataGrid-columnSeparator':
    {
      display: 'none'
    },
  '.MuiDataGrid-row:hover': {
    backgroundColor: transparentColors.whiteShade2
  },
  '.MuiDataGrid-row.Mui-selected': {
    backgroundColor: transparentColors.whiteShade3,
    '&:hover': {
      backgroundColor: transparentColors.whiteShade2
    }
  },
  '.MuiDataGrid-cellCheckbox.MuiDataGrid-cell:focus-within': {
    outline: 'none'
  },
  '.MuiCheckbox-root': {
    color: `${primaryColors.orange} !important`,
    '&:hover': {
      color: buttonOrange.contained.backgroundHover
    },
    '&.Mui-checked': {
      color: `${primaryColors.orange}`,
      '&:hover': {
        color: buttonOrange.contained.backgroundHover
      }
    }
  },
  '& .MuiDataGrid-cell:focus': {
    outline: 0
  },
  '& .MuiDataGrid-cellCheckbox': {
    '& .MuiDataGrid-checkboxInput': {
      padding: 0
    }
  },
  '& .MuiDataGrid-columnHeader:focus-within': {
    outline: 'none'
  },
  '& .MuiDataGrid-container--top [role=row]': {
    background: orangeShades.shade2
  },
  '& .MuiDataGrid-columnSeparator': {
    color: primaryColors.black,
    borderRadius: 0,
    WebkitTapHighlightColor: primaryColors.black,
    '&:hover': {
      color: primaryColors.orange,
      borderRadius: 0
    }
  },
  '& .MuiDataGrid-columnHeaderTitleContainerContent .MuiCheckbox-root': {
    padding: 0
  },
  '.MuiDataGrid-row--borderBottom .MuiDataGrid-scrollbarFiller': {
    border: 0
  },
  '.MuiDataGrid-main > div:last-child:empty': {
    display: 'none'
  }
}

export const paginationStyles = {
  '& .MuiPaginationItem-root': {
    color: primaryColors.white,
    '&:focus': {
      outline: 0
    },
    '&:hover': {
      backgroundColor: transparentColors.whiteShade1
    }
  },

  '& .MuiPaginationItem-root.Mui-selected': {
    backgroundColor: transparentColors.whiteShade3,
    color: primaryColors.white,
    '&:hover': {
      backgroundColor: transparentColors.whiteShade2
    }
  },

  '& .MuiPaginationItem-root .MuiSvgIcon-root': {
    color: primaryColors.white
  },
  '& .MuiPaginationItem-root.Mui-disabled': {
    color: whiteShades.shade1
  }
}
